import { defineMessages } from 'react-intl';

export const subItemQuantityEventMessages = defineMessages({
    quantityEvents: {
        id: 'quantity-events',
        defaultMessage: 'Quantity events',
    },
    quantityEvent: {
        id: 'quantity-event',
        defaultMessage: 'Quantity event',
    },
    quantityEventTableBadge: {
        id: 'quantity-event-table-badge',
        defaultMessage: 'Event',
    },
    quantityEventsTableBadge: {
        id: 'quantity-events-table-badge',
        defaultMessage: 'Events',
    },
    recordedAt: {
        id: 'recorded-at',
        defaultMessage: 'Recorded at',
    },
    eventType: {
        id: 'event-type',
        defaultMessage: 'Event type',
    },
    quantity: {
        id: 'quantity',
        defaultMessage: 'Quantity',
    },
    set: {
        id: 'set',
        defaultMessage: 'Set',
    },
    increment: {
        id: 'increment',
        defaultMessage: 'Increment',
    },
    decrement: {
        id: 'decrement',
        defaultMessage: 'Decrement',
    },
});
